export default __webpack_public_path__ + "static/media/Olushola_Ayodele_AHV_In_Moms_We_Trust.915fe4db.jpg";